import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';
import { ellipsis } from '@styles/common';

export const WhiteBlock = styled('div')`
  width: 100%;

  position: fixed;
  top: 0px;
  z-index: 999;
  transition: opacity 150ms ease;
  will-change: opacity;
  padding: 0.5rem 1rem;
  margin-top: 0rem;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

  a {
    margin-top: 0rem;
  }

  @media (min-width: ${breakpoints.md}) {
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
    padding: 2rem 0;

    a {
      width: auto;
      display: block;
      margin-top: 0rem;
    }
  }
`;

export const WhiteBlockFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-inline: 1rem;
  }
`;

export const WhiteBlockTitle = styled.p`
  ${ellipsis}
  ${theme.typography.labelLarge}
  @media (min-width: ${breakpoints.lg}) {
    ${theme.typography.titleLarge}
  }
`;

export const WhiteBlockAnnotation = styled.span`
  color: ${theme.color.text.secondary};
  ${theme.typography.bodyRegular}
  margin-left: 6px;
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.bodyLarge}
    margin-left: 12px;
  }
`;
